export default __webpack_public_path__ + "static/media/uranus_space_club.ee118db6.jpg";